import { render, staticRenderFns } from "./mandate-table.vue?vue&type=template&id=23732fc1&scoped=true&"
import script from "./mandate-table.ts?vue&type=script&lang=ts&"
export * from "./mandate-table.ts?vue&type=script&lang=ts&"
import style0 from "./mandate-table.scss?vue&type=style&index=0&id=23732fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23732fc1",
  null
  
)

export default component.exports